// Dictionary of legislative terms and explanations

import { translation } from './translate';

const legislativeTerms = [
  {
    fi: {
      term: 'Asetus',
      explanation:
        'Säädös, jonka antaa tasavallan presidentti, valtioneuvosto tai ministeriö laissa säädetyn valtuuden nojalla',
      source_text: 'Valtioneuvoston termipankki: Asetus',
      source_url:
        'https://valter.sanakirja.fi/all/all/asetus',
    },
    se: {
      term: 'Förordning',
      explanation:
        'En författning som utfärdas av republikens president, statsrådet eller ett ministerium med stöd av lagens bemyndigande.',
      source_text:
        'Termbank Valter: Förordning Förordning (flera språk) | Valter',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Asetus (EU)',
      explanation:
        'Euroopan unionin antama säädös, jota on sovellettava suoraan ja yhdenmukaisesti kaikissa EU-maissa heti, kun asetus tulee voimaan. Eikä se vaadi toimenpiteitä tullakseen osaksi kansallista lainsäädäntöä.',
      source_text:
        'Euroopan komissio: EU-lainsäädännön tyypit',
      source_url:
        'https://commission.europa.eu/law/law-making-process/types-eu-law_fi',
    },
    se: {
      term: 'Förordning (EU)',
      explanation:
        'En rättsakt som antas av Europeiska unionen och som ska tillämpas direkt och enhetligt i alla EU-länder från det att förordningen träder i kraft. Den kräver inga nationella åtgärder för att bli en del av den nationella lagstiftningen.',
      source_text:
        'Europeiska kommissionen: Typer av EU-rättsakter Typer av EU-rättsakter -i Europeiska kommissionen',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Asiantuntijalausunto',
      explanation:
        'Jonkin tahon antama, asiantuntemukseen perustuva selvitys tai kannanotto käsiteltävään asiaan. Yleensä kirjallinen.',
      source_text:
        'Valtioneuvoston termipankki: Asiantuntijalausunto',
      source_url:
        'https://valter.sanakirja.fi/all/all/Asiantuntijalausunto',
    },
    se: {
      term: 'Sakkunnigutlåtande',
      explanation:
        'Utlåtande eller ställningstagande av en expert i en aktuell fråga, baserat på sakkunskap. Vanligen skriftligt.',
      source_text:
        'Termbank Valter: Anmärkning Asiantuntijalausunto (flera språk) | Valter',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Direktiivi',
      explanation:
        'Euroopan unionin antama säädös, jolla säädetään velvoittavista tavoitteista. Direktiivit määrittelevät tietyn lopputuloksen, jonka jäsenvaltioiden on saavutettava, mutta ne jättävät kansallisille viranomaisille ja lainsäätäjille vapauden valita parhaiten soveltuvat keinot tämän tavoitteen saavuttamiseksi.',
      source_text: 'Euroopan unioni: Säädöstyypit',
      source_url:
        'https://european-union.europa.eu/institutions-law-budget/law/types-legislation_fi',
    },
    se: {
      term: 'Direktiv',
      explanation:
        'En rättsakt antagen av Europeiska unionen som fastställer bindande mål. ,Direktiv anger ett specifikt resultat som medlemsstaterna ska uppnå, men de ,lämnar åt de nationella myndigheterna och lagstiftarna att bestämma de mest ,lämpliga medlen för att målet ska uppnås.',
      source_text:
        'Europeiska unionen: Typer av rättsakter',
      source_url:
        'https://european-union.europa.eu/institutions-law-budget/law/types-legislation_sv',
    },
  },
  {
    fi: {
      term: 'Eduskunnan täysistunto',
      explanation:
        'Eduskunnan virallinen istunto, johon kansanedustajat kokoontuvat käymään eduskuntakeskusteluja, eli käsittelemään eri asioita. Eduskunnan täysistunto on lainsäädäntötyön keskeinen tapahtumapaikka.',
      source_text: 'Eduskunta: Täysistunnot eduskunnassa',
      source_url: 'https://www.eduskunta.fi/taysistunto',
    },
    se: {
      term: 'Plenum',
      explanation:
        'Riksdagens officiella sammanträde där ledamöterna samlas för politiska debatter och behandling av olika frågor. Plenum är huvudforumet för riksdagens lagstiftningsarbete.',
      source_text: 'Riksdagen: Plenum',
      source_url:
        'https://www.eduskunta.fi/SV/taysistunto/Sidor/default.aspx',
    },
  },
  {
    fi: {
      term: 'Eduskuntakeskustelu',
      explanation:
        'Eduskunnan istunto, jossa käsitellään tiettyä asiaa tai aihepiiriä esimerkiksi hallituksen esitystä. Istunto, jossa kansanedustajat ilmaisevat näkemyksiään ja käyvät keskustelua käsiteltävästä aiheesta.',
      source_text: '',
      source_url: '',
    },
    se: {
      term: 'Riksdagsdebatt',
      explanation:
        'Ett riksdagssammanträde där ledamöterna diskuterar och uttrycker sina åsikter om en viss fråga eller ett specifikt ämnesområde, till exempel ett regeringsförslag.',
      source_text: '',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Hallituksen esitys',
      explanation:
        'Valtioneuvoston antama esitys eduskunnalle, jossa on yksi tai useampi lakiehdotus.',
      source_text:
        'Tieteen termipankki: Hallituksen esitys',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:hallituksen_esitys',
    },
    se: {
      term: 'Regeringsproposition',
      explanation:
        'Ett förslag från regeringen till riksdagen i syfte att inleda behandlingen av  eller flera lagförslag för behandling.',
      source_text:
        'Tieteen termipankki: Hallituksen esitys',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:hallituksen_esitys',
    },
  },
  {
    fi: {
      term: 'Hylkääminen (lakialoitteen hylkääminen)',
      explanation:
        'Eduskunta päättää, ettei ehdotettua lakia saateta voimaan, eli hylkää sen, lakiehdotuksen toisessa käsittelyssä.',
      source_text:
        'Eduskunta: Lakien säätäminen eduskunnassa',
      source_url:
        'https://www.eduskunta.fi/FI/naineduskuntatoimii/eduskunnan_tehtavat/lakiensaataminen/Sivut/default.aspx',
    },
    se: {
      term: 'Avslag (av ett lagförslag)',
      explanation:
        'När riksdagen under lagförslagets andra behandling beslutar att förslaget inte ska antas, alltså förkastar lagförslaget.',
      source_text:
        'Riksdagen: Så här stiftar riksdagen lagar',
      source_url:
        'https://www.eduskunta.fi/SV/naineduskuntatoimii/eduskunnan_tehtavat/lakiensaataminen/Sidor/default.aspx',
    },
  },
  {
    fi: {
      term: 'Itsehallinto',
      explanation:
        'Kunnan tai maakunnan oikeus hoitaa itse määrittämänsä tai lailla osoitetut tehtävät. Itsehallintoon kuuluu oikeus päättää myös hallinnosta ja taloudesta.',
      source_text:
        'Valtioneuvoston termipankki: Itsehallinto',
      source_url:
        'https://valter.sanakirja.fi/all/all/itsehallinto',
    },
    se: {
      term: 'Självstyre',
      explanation:
        'Kommunens eller landskapets rätt att själv sköta de uppgifter som de åtagit sig eller som ålagts kommunen genom lag och att besluta om sin förvaltning, organisation och ekonomi.',
      source_text: 'Termbank Valter: Självstyre',
      source_url:
        'https://valter.sanakirja.fi/all/all/itsehallinto',
    },
  },
  {
    fi: {
      term: 'Kansalaisaloite',
      explanation:
        'Kansalaisten oikeus/mahdollisuus tehdä eduskunnalle aloite lain säätämiseksi taikka voimassa olevan lain muuttamiseksi tai kumoamiseksi. Aloite vaatii vähintään 50 000 Suomen kansalaisen kannatusilmoituksen.',
      source_text: 'Eduskunta: Kansalaisaloitteet',
      source_url:
        'https://www.eduskunta.fi/FI/valtiopaivaasiat/Sivut/Kansalaisaloitteet.aspx',
    },
    se: {
      term: 'Medborgarinitiativ',
      explanation:
        'Medborgarnas rätt eller möjlighet att lägga fram ett initiativ i riksdagen om att en lag ska stiftas, ändras eller upphävas. Initiativet kräver stöd från minst 50 000 finska medborgare.',
      source_text: 'Riksdagen: Medborgarintitativ',
      source_url:
        'https://www.eduskunta.fi/SV/valtiopaivaasiat/Sidor/Kansalaisaloitteet.aspx',
    },
  },
  {
    fi: {
      term: 'Kokeilulainsäädäntö',
      explanation:
        'Lainsäädäntö, joka on kokeilumielessä voimassa ajallisesti tai alueellisesti rajatun ajan. Tarkoituksena on usein selvittää toimien vaikutuksia.',
      source_text: 'Finlex: Kokeiluopas',
      source_url:
        'https://kokeiluohje.finlex.fi/ohje/kokeilulla-tulee-olla-hyvaksyttava-tavoite/',
    },
    se: {
      term: 'Försökslagstiftning',
      explanation:
        'Lagstiftning som är i kraft under en begränsad tid eller inom ett avgränsat område, i syfte att pröva eller utvärdera lagens effekter.',
      source_text:
        'Finlex: Handbok i att bereda försökslagar',
      source_url:
        'https://kokeiluohje.finlex.fi/sv/ohje/kokeilulla-tulee-olla-hyvaksyttava-tavoite/',
    },
  },
  {
    fi: {
      term: 'Kumoamissäädös',
      explanation:
        'Säädös, jolla kumotaan alkuperäinen säädös tai lainkohta.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/15-uusi-saados-muutossaados-vai-kumoamissaados/15-1/',
    },
    se: {
      term: 'Upphävande författning',
      explanation:
        'En föreskrift som upphäver en tidigare förskrift eller en bestämmelse i lag.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/15-uusi-saados-muutossaados-vai-kumoamissaados/15-1/',
    },
  },
  {
    fi: {
      term: 'Lainkohta',
      explanation:
        'Viittaa tiettyyn osaan säädöstä. Säädös koostuu lainkohdista esimerkiksi pykälistä, momenteista sekä kohdista ja alakohdista.',
      source_text: 'Tieteen termipankki: Lainkohta',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:lainkohta',
    },
    se: {
      term: 'Lagrum / lagbestämmelse',
      explanation:
        'Avser en viss del av lagtext. En lagtext består av ett eller flera lagrum, exempelvis paragrafer, moment, punkter eller underpunkter.',
      source_text: 'Tieteen termipankki: Lainkohta',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:lainkohta',
    },
  },
  {
    fi: {
      term: 'Lainsäädäntösuunnitelma',
      explanation:
        'Lainsäädäntösuunnitelma sisältää alustavat tiedot niistä lainvalmisteluhankkeista, joista hallitus suunnittelee antavansa esityksen eduskunnan istuntokaudella.',
      source_text:
        'Valtioneuvosto: Hallituksen lainsäädäntöohjelma ja -suunnitelma',
      source_url:
        'https://valtioneuvosto.fi/lainsaadantosuunnitelma',
    },
    se: {
      term: 'Lagstiftningsplan',
      explanation:
        'Lagstiftningsplanen innehåller aktuella uppgifter om de regeringspropositioner som regeringen har för avsikt att lämna till riksdagen under sessionsperioden.',
      source_text:
        'Statsrådet: Regeringens lagstiftningsprogram och lagstiftningplan',
      source_url:
        'https://valtioneuvosto.fi/sv/beslut/regeringens-lagstiftningsprogram-och-lagstiftningsplan',
    },
  },
  {
    fi: {
      term: 'Lainsäädäntövalta',
      explanation:
        'Lainsäädäntövalta, eli toimivalta säätää lakeja, on eduskunnalla.',
      source_text: 'Suomen perustuslaki 731/1999',
      source_url: '',
    },
    se: {
      term: 'Lagstiftande makt',
      explanation:
        'Rätten att stifta lagar. Utövas av riksdagen.',
      source_text: 'Finlands grundlag 731/1999',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Lainsäätämisjärjestys',
      explanation:
        'Menettelytapa, jolla eduskunnassa päätetään lakiehdotuksen hyväksymisestä.',
      source_text:
        'Valtioneuvoston termipankki: Lainsäätämisjärjestys',
      source_url:
        'https://valter.sanakirja.fi/all/all/Lains%C3%A4%C3%A4t%C3%A4misj%C3%A4rjestys',
    },
    se: {
      term: 'Lagstiftningsordning',
      explanation:
        'Grundlagsfäst procedur som riksdagen tillämpar vid beslut om att anta ett lagförslag.',
      source_text: 'Termbank Valter: Lagstiftningsordning',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Laintarkastus',
      explanation:
        'Laintarkastuksessa tarkastetaan hallituksen esityksen luonnos suomeksi ja ruotsiksi. Luonnos, jonka kieliasut eivät vastaa toisiaa, tai joka ei noudata ohjeita, voidaan palauttaa takaisin lainvalmisteluun.',
      source_text: 'Finlex: Lainvalmistelun prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/4-jatkovalmistelu/4-9-laintarkastus/',
    },
    se: {
      term: 'Laggranskning',
      explanation:
        'Vid laggranskning granskas regeringens proposition språkligt både på finska och svenska. Ett utkast vars språkversioner inte stämmer överens, eller som inte följer gällande riktlinjer, kan skickas tillbaka för fortsatt lagberedning.',
      source_text:
        'Finlex: Processhandbok för lagberedningen',
      source_url:
        'https://lainvalmistelu.finlex.fi/sv/4-jatkovalmistelu/4-9-laintarkastus/',
    },
  },
  {
    fi: {
      term: 'Lakialoite',
      explanation:
        'Kansanedustaja voi tehdä lakialoitteen, jolla hän ehdottaa uutta lakia tai olemassaolevan lain muuttamista tai kumoamista.',
      source_text: 'Valtioneuvoston termipankki',
      source_url:
        'https://valter.sanakirja.fi/all/all/lakialoite',
    },
    se: {
      term: 'Lagmotion',
      explanation:
        'Motion som en riksdagsledamot kan väcka med förslag om att stifta, ändra eller upphäva en lag.',
      source_text: 'Termbank Valter: Lagmotion',
      source_url:
        'https://valter.sanakirja.fi/all/all/lakialoite',
    },
  },
  {
    fi: {
      term: 'Lakiehdotus',
      explanation:
        'Ehdotus uuden lain säätämisestä tai voimassa olevan lain muuttamisesta tai kumoamisesta. Ehdotus voi olla osa hallituksen lakiesitystä, kansanedustajan lakialoitetta taikka valiokunnan mietintöä.',
      source_text:
        'Valtioneuvoston kanslia, Lainsäädäntösanasto 2023. s. 16',
      source_url: '',
    },
    se: {
      term: 'Lagförslag',
      explanation:
        'Ett förslag om att stifta en ny lag eller ändra eller upphäva befintlig lag. Lagförslaget kan ingå i en regeringsproposition, en riksdagsledamots motion eller ett utskottsbetänkande.',
      source_text:
        'Statsrådets kansli: Lainsäädäntösanasto 2023. s. 16',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Lakiesitys',
      explanation:
        'Viittaa hallituksen esitykseen, joka sisältää lakiehdotuksen ja sen perustelut.',
      source_text:
        'Valtioneuvoston kanslia, Lainsäädäntösanasto 2023. s. 17',
      source_url: '',
    },
    se: {
      term: 'Proposition',
      explanation:
        'Regeringens proposition som innehåller ett lagförslag och dess motiveringar.',
      source_text:
        'Statsrådets kansli, Lainsäädäntösanasto 2023. s. 17',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Lausuntokierros',
      explanation:
        'Lainvalmistelun kuluessa käytävä kuulemismenettely, johon kenellä tahansa on mahdollisuus osallistua. Lausuntokierroksella pyydetään kannanottoja lakiehdotukseen.',
      source_text: 'Finlex: Lainvalmistelun prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/3-lausuntomenettely/#esittely',
    },
    se: {
      term: 'Remissförfarande',
      explanation:
        'Ett hörande som genomförs under lagberedningen, där alla intresserade har möjlighet att delta. I samband med remissförfarandet begärs synpunkter på lagförslaget.',
      source_text:
        'Finlex: Processhandbok för lagberedningen',
      source_url:
        'https://lainvalmistelu.finlex.fi/sv/3-lausuntomenettely/',
    },
  },
  {
    fi: {
      term: 'Lausuntopyyntö',
      explanation:
        'Lainvalmistelussa pyydetään kirjallisia lausuntoja sidosryhmiltä lausuntopyynnöllä. Lausuntopyynnöt julkaistaan esimerkiksi lausuntopalvelu.fi-palvelussa.',
      source_text: 'Finlex: Lainvalmistelun prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/3-lausuntomenettely/',
    },
    se: {
      term: 'Begäran om utlåtande',
      explanation:
        'Under lagberedningen begärs skriftliga utlåtanden från intressentgrupper genom en begäran om utlåtande. Begäran om utlåtande publiceras exempelvis på tjänsten utlåtande.fi',
      source_text:
        'Finlex: Processhandbok för lagberedningen',
      source_url:
        'https://lainvalmistelu.finlex.fi/sv/3-lausuntomenettely/',
    },
  },
  {
    fi: {
      term: 'Ministeriö',
      explanation:
        'Ministeriö on valtioneuvoston osasto, jonka johdossa on ministeri. Ministeriöt huolehtivat asioiden valmistelusta ja hallinnosta omalla toimialallaan.',
      source_text:
        'Valtioneuvosto: Valtioneuvoston toiminta',
      source_url:
        'https://valtioneuvosto.fi/tietoa/valtioneuvoston-toiminta',
    },
    se: {
      term: 'Ministerium',
      explanation:
        'En avdelning inom statsrådet som leds av en minister. Ministerierna ansvarar för beredning och förvaltning inom sitt verksamhetsområde.',
      source_text: 'Statsrådet: Så här arbetar statsrådet',
      source_url:
        'https://valtioneuvosto.fi/sv/info/sa-har-arbetar-statsradet',
    },
  },
  {
    fi: {
      term: 'Ministeriön asetus',
      explanation:
        'Säädös, jonka antaa ministeriö laissa säädetyn valtuuden nojalla.',
      source_text:
        'Valtioneuvoston termipankki: Ministerin asetus',
      source_url:
        'https://valter.sanakirja.fi/all/all/ministeri%C3%B6n%20asetus',
    },
    se: {
      term: 'Ministeriets förordning',
      explanation:
        'En förordning som utfärdas av ett ministerium med stöd av lagstadgad befogenhet.',
      source_text:
        'Termbank Valter: Ministeriets förordning',
      source_url:
        'https://valter.sanakirja.fi/all/all/ministeri%C3%B6n%20asetus',
    },
  },
  {
    fi: {
      term: 'Momentti',
      explanation:
        'Lainsäädännössä olevan pykälän osa. Säädös jakautuu pykäliin ja pykälät momentteihin.',
      source_text: 'Tieteen termipankki: Momentti',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:momentti',
    },
    se: {
      term: 'Moment',
      explanation:
        'Del av en paragraf i lagstiftningen. Författningar är indelade i paragrafer och paragraferna i moment.',
      source_text: 'Tieteen termipankki: Momentti',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:momentti',
    },
  },
  {
    fi: {
      term: 'Muutossäädös',
      explanation:
        'Säädös, jolla alkuperäiseen säädökseen tehdään muutos.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/15-uusi-saados-muutossaados-vai-kumoamissaados/15-1/',
    },
    se: {
      term: 'Ändringsförordning',
      explanation:
        'En författning genom vilken en ändring görs i en ursprunglig författning.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/15-uusi-saados-muutossaados-vai-kumoamissaados/15-1/',
    },
  },
  {
    fi: {
      term: 'Pykälä',
      explanation:
        'Lait ja muut säädökset jaetaan pykäliin. Pykäliin viitataan numerolla tai numero-kirjainyhdistelmällä sekä §-merkillä.',
      source_text: 'Valtioneuvoston termipankki: Pykälä',
      source_url:
        'https://valter.sanakirja.fi/all/all/pyk%C3%A4l%C3%A4',
    },
    se: {
      term: 'Paragraf',
      explanation:
        'Lagar och andra författningar är indelade i paragrafer. Paragrafer anges med ett nummer eller en siffer-bokstavskombination tillsammans med tecknet §.',
      source_text: 'Termbank Valter: Paragraf',
      source_url:
        'https://valter.sanakirja.fi/all/all/pyk%C3%A4l%C3%A4',
    },
  },
  {
    fi: {
      term: 'Päätös (EU)',
      explanation:
        'Päätös osoitetaan nimetyille tahoille, ja se on näiden nimettyjen tahojen osalta oikeudellisesti velvoittava.',
      source_text:
        'Euroopan komissio: EU-lainsäädännön tyypit',
      source_url:
        'https://commission.europa.eu/law/law-making-process/types-eu-law_fi',
    },
    se: {
      term: 'Beslut (EU)',
      explanation:
        'Beslut som riktas till namngivna parter och är juridiskt bindande för dem.',
      source_text:
        'Europeiska kommissionen: Typer av EU-rättsakter',
      source_url:
        'https://commission.europa.eu/law/law-making-process/types-eu-law_sv',
    },
  },
  {
    fi: {
      term: 'Raukeaminen (lakiehdotuksen raukeaminen)',
      explanation:
        'Lakiehdotus, jota ei käsitellä eduskunnassa, raukeaa vaalikauden vaihtuessa.',
      source_text: '',
      source_url: '',
    },
    se: {
      term: 'Upphörande av lagförslag',
      explanation:
        'Ett lagförslag som inte behandlas i riksdagen förfaller när valperioden upphör.',
      source_text:
        'Riksdagen: Så här stiftar riksdagen lagar',
      source_url:
        'https://www.eduskunta.fi/SV/naineduskuntatoimii/eduskunnan_tehtavat/lakiensaataminen/Sidor/default.aspx',
    },
  },
  {
    fi: {
      term: 'Siirtymäsäännös',
      explanation:
        'Säännös, jota sovelletaan kun siirrytään vanhan lain soveltamisesta uuden lain soveltamiseen.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/21-siirtymasaannokset/21-1/',
    },
    se: {
      term: 'Övergångsbestämmelse',
      explanation:
        'En bestämmelse som tillämpas vid övergången från en tidigare lag till en ny lag.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/21-siirtymasaannokset/21-1/',
    },
  },
  {
    fi: {
      term: 'Suositus (EU)',
      explanation:
        'Suosituksessa EU:n toimielimet kertovat näkemyksiään ja ehdottavat toimenpiteitä. Suositukset eivät ole oikeudellisesti sitovia.',
      source_text:
        'Euroopan komissio: EU-lainsäädännön tyypit',
      source_url:
        'https://commission.europa.eu/law/law-making-process/types-eu-law_fi',
    },
    se: {
      term: 'Rekommendation (EU)',
      explanation:
        'Med en rekommendation kan EU:s institutioner framföra åsikter och föreslå åtgärder. Rekommendationer är inte rättsligt bindande.',
      source_text:
        'Europeiska kommissionen: Typer av EU-rättsakter',
      source_url:
        'https://commission.europa.eu/law/law-making-process/types-eu-law_sv',
    },
  },
  {
    fi: {
      term: 'Säädös',
      explanation:
        'Viittaa lakeihin, asetuksiin sekä muihin alempien viranomaisten antamiin oikeussääntöihin.',
      source_text:
        'Oikeusministeriö, Lainlaatijan opas osa 2. Lakitekniikka 2010',
      source_url:
        'https://julkaisut.valtioneuvosto.fi/bitstream/handle/10024/76237/43_2010_lainlaatijan_opas.pdf?sequence=1',
    },
    se: {
      term: 'Författning',
      explanation:
        'Ett samlingsbegrepp för lagar, förordningar och andra rättsregler som utfärdats av myndigheter på lägre nivå.',
      source_text:
        'Oikeusministeriö, Lainlaatijan opas osa 2. Lakitekniikka 2010',
      source_url:
        'https://julkaisut.valtioneuvosto.fi/bitstream/handle/10024/76237/43_2010_lainlaatijan_opas.pdf?sequence=1',
    },
  },
  {
    fi: {
      term: 'Säädöskokoelma',
      explanation:
        'Suomen säädöskokoelmassa julkaistaan Suomessa säädetyt lait, asetukset ja määräykset, valtiosopimukset sekä tietyt eduskunnan toimintaan liittyvät säädökset.',
      source_text:
        'Laki Suomen säädöskokoelmasta (188/2000)',
      source_url: '',
    },
    se: {
      term: 'Författningssamling',
      explanation:
        'I Finlands författningssamling publiceras de lagar, förordningar och föreskrifter som har antagits i Finland, internationella avtal samt vissa författningar som rör riksdagens verksamhet.',
      source_text:
        'Lag om Finlands författningssamling (188/2000)',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Säädösvalmistelu',
      explanation:
        'Oikeudellisen sääntelyn valmistelua, jonka tarkoituksena on laatia sääntelyehdotus.',
      source_text: 'Tieteen termipankki: Lainvalmistelu',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:lainvalmistelu',
    },
    se: {
      term: 'Lagberedning',
      explanation:
        'Förberedelse av rättslig reglering med syftet att utarbeta ett förslag till lagstiftning eller annan reglering.',
      source_text: 'Termbank Valter: Lagberedning',
      source_url:
        'https://valter.sanakirja.fi/all/all/s%C3%A4%C3%A4d%C3%B6svalmistelu',
    },
  },
  {
    fi: {
      term: 'Säännös',
      explanation:
        'Pykälään sisältyvä oikeusnormi eli oikeudellinen toimintaohje (esim. käsky tai kielto)',
      source_text: 'Tieteen termipankki: Oikeussäännös',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:oikeuss%C3%A4%C3%A4nn%C3%B6s',
    },
    se: {
      term: 'Rättsregel',
      explanation:
        'En rättsnorm som ingår i en paragraf, det vill säga en juridisk handlingsanvisning (t.ex. en befallning eller ett förbud).',
      source_text: 'Termbank Valter: Rättsregel',
      source_url:
        'https://valter.sanakirja.fi/all/all/s%C3%A4%C3%A4nn%C3%B6s',
    },
  },
  {
    fi: {
      term: 'Tasavallan presidentin asetus',
      explanation:
        'Tasavallan presidentin antama, lakia alemmanasteinen säädös',
      source_text:
        'Valtioneuvoston kanslia, Lainsäädäntösanasto 2023. s. 4',
      source_url: '',
    },
    se: {
      term: 'Republikens presidents förordning',
      explanation:
        'En förordning utfärdad av republikens president, som är underställd lagen i hierarkin.',
      source_text:
        'Statsrådets kansli, Lainsäädäntösanasto 2023, s. 4.',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Työryhmä',
      explanation:
        'Lainvalmistelussa erikseen koottu ryhmä lainvalmistelijoita, viranomaisia ja muita sidosryhmiä edustavia henkilöitä. Ministeriö asettaa työryhmän määräajaksi lainvalmisteluun liittyvään tehtävään.',
      source_text: 'Finlex: Lainvalmistelun prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/2b-perusvalmistelu-valmisteluelin/#esittely',
    },
    se: {
      term: 'Arbetsgrupp',
      explanation:
        'En grupp av lagberedare, myndighetsrepresentanter och andra berörda personer, som arbetar med en lagberedning. Arbetsgruppen tillsätts av ett ministerium för en begränsad tid för att utföra uppgifter i samband med lagberedningen.',
      source_text: 'Finlex: Lainvalmistelun prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/2b-perusvalmistelu-valmisteluelin/#esittely',
    },
  },
  {
    fi: {
      term: 'Täytäntöönpano',
      explanation:
        'Täytäntöönpanolla tarkoitetaan erilaisia viranomaisten toimenpiteitä, joilla hyväksytty laki tuodaan käytäntöön.',
      source_text: 'Finlex: Prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/taytantoonpano/#esittely',
    },
    se: {
      term: 'Verkställande',
      explanation:
        'Med verkställighet avses olika åtgärder som myndigheter vidtar för att tillämpa en antagen lag.',
      source_text: 'Finlex: Prosessiopas',
      source_url:
        'https://lainvalmistelu.finlex.fi/taytantoonpano/#esittely',
    },
  },
  {
    fi: {
      term: 'Vahvistaa laki',
      explanation:
        'Eduskunnan hyväksymän lain vahvistamisesta päättää tasavallan presidentti. Mikäli presidentti ei vahvista lakia, se voidaan kuitenkin saattaa voimaan eduskunnan päätöksellä.',
      source_text:
        'Eduskunta: Lakien säätäminen eduskunnassa',
      source_url:
        'https://www.eduskunta.fi/FI/naineduskuntatoimii/eduskunnan_tehtavat/lakiensaataminen/Sivut/default.aspx',
    },
    se: {
      term: 'Stadfästa en lag',
      explanation:
        'Presidenten beslutar om stadfästande av en lag som godkänts av riksdagen. Om presidenten inte stadfäster lagen kan den ändå träda i kraft genom ett beslut av riksdagen.',
      source_text:
        'Riksdagen: Så här stiftar riksdagen lagar',
      source_url:
        'https://www.eduskunta.fi/SV/naineduskuntatoimii/eduskunnan_tehtavat/lakiensaataminen/Sidor/default.aspx',
    },
  },
  {
    fi: {
      term: 'Valiokunnan lausunto',
      explanation:
        'Valiokuntaa voidaan pyytää antamaan lausunto toiselle valiokunnalle jostakin sen valmisteltavana olevasta asiasta. Esimerkiksi perustuslakivaliokunta voi antaa lausuntoja lakiehdotusten perustuslainmukaisuudesta.',
      source_text: 'Eduskunta: Valiokuntien lausunnot',
      source_url:
        'https://www.eduskunta.fi/FI/valtiopaivaasiat/Sivut/Valiokuntien-lausunnot.aspx',
    },
    se: {
      term: 'Utskottets utlåtanden',
      explanation:
        'Ett utskott kan ombes lämna ett yttrande till ett annat utskott om ett ärende som det förbereder. Till exempel kan grundlagsutskottet ge yttranden om lagförslagens förenlighet med grundlagen.',
      source_text: 'Riksdagen: Utskottets utlåtanden',
      source_url:
        'https://www.eduskunta.fi/SV/valtiopaivaasiat/Sidor/Valiokuntien-lausunnot.aspx',
    },
  },
  {
    fi: {
      term: 'Valiokunnan mietintö',
      explanation:
        'Valiokunnan mietintö on valiokunnan valmistelun lopputuloksena syntyvä asiakirja, jonka pohjalta eduskunta päättää lakiehdotuksen hyväksymisestä tai hylkäämisestä.',
      source_text: 'Eduskunta: Valiokuntien mietinnöt',
      source_url:
        'https://www.eduskunta.fi/FI/valtiopaivaasiat/Sivut/Valiokuntien-mietinnot.aspx',
    },
    se: {
      term: 'Utskottens betänkanden',
      explanation:
        'Ett dokument som är resultatet av ett utskotts förberedelser och som ligger till grund för riksdagens beslut om ett lagförslag ska godkännas eller förkastas.',
      source_text: 'Riksdagen: Utskottens betänkanden',
      source_url:
        'https://www.eduskunta.fi/SV/valtiopaivaasiat/Sidor/Valiokuntien-mietinnot.aspx',
    },
  },
  {
    fi: {
      term: 'Valiokunta',
      explanation:
        'Valiokunta on eduskunnan toimielin, joka valmistelee päätöksiä eduskunnan päätöksentekoon. Lakiehdotukset käsitellään yhdessä tai useammassa valiokunnassa ennen kuin eduskunta päättää täysistunnossa niiden hyväksymisestä tai hylkäämisestä.',
      source_text: 'Eduskunta: Valiokunnat',
      source_url:
        'https://www.eduskunta.fi/FI/valiokunnat/Sivut/default.aspx',
    },
    se: {
      term: 'Utskott',
      explanation:
        'Ett utskott är ett organ inom riksdagen som förbereder ärenden för riksdagens beslut. Lagförslag behandlas i ett eller flera utskott innan riksdagen i plenum fattar beslut om deras godkännande eller förkastande.',
      source_text: 'Riksdagen: Utskott',
      source_url:
        'https://www.eduskunta.fi/SV/valiokunnat/Sidor/default.aspx',
    },
  },
  {
    fi: {
      term: 'Valmisteluasiakirja',
      explanation:
        'Ministeriön lainvalmistelun kuluessa tuottama tai vastaanottama asiakirja. Asiakirjan rooli prosessissa vaihtelee sen tyypin mukaan.',
      source_text: '',
      source_url: '',
    },
    se: {
      term: 'Beredningsunderlag',
      explanation:
        'Ett dokument som ett ministerium framställer eller tar emot i samband med lagberedning. Dokumentets roll i processen varierar beroende på dess typ.',
      source_text: 'Utrikesministeriet: Offentlighetslagen',
      source_url:
        'https://oikeusministerio.fi/sv/broschyr-om-offentlighetslagen',
    },
  },
  {
    fi: {
      term: 'Valtioneuvosto',
      explanation:
        'Toimielin, joka koostuu pääministeristä, ministereistä ja valtioneuvoston oikeuskanslerista, ja joka käyttää toimeenpanovaltaa.',
      source_text: 'Tieteen termipankki: Valtioneuvosto',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:valtioneuvosto_(valtios%C3%A4%C3%A4nt%C3%B6oikeus)',
    },
    se: {
      term: 'Statsrådet',
      explanation:
        'Ett organ som består av statsministern, ministrarna och justitiekanslern i statsrådet och som utövar den verkställande makten.',
      source_text: 'Termbank Valter: Statsrådet',
      source_url:
        'https://valter.sanakirja.fi/all/all/valtioneuvosto',
    },
  },
  {
    fi: {
      term: 'Valtioneuvoston asetus',
      explanation:
        'Valtioneuvoston antama, lakia alemman asteinen säädös.',
      source_text:
        'Valtioneuvoston kanslia, Lainsäädäntösanasto 2023. s. 4',
      source_url: '',
    },
    se: {
      term: 'Statsrådets förordning',
      explanation:
        'Förordning utfärdad av statsrådet, som är en författning på lägre nivå än lag.',
      source_text:
        'Statsrådets kansli, Lainsäädäntösanasto 2023, s. 4',
      source_url: '',
    },
  },
  {
    fi: {
      term: 'Valtioneuvoston yleisistunto',
      explanation:
        'Valtioneuvoston yleisistunnossa hallitus tekee päätökset mm. siitä, mitkä hallituksen esitykset annetaan eduskunnalle.',
      source_text: 'Valtioneuvoston termipankki',
      source_url:
        'https://valter.sanakirja.fi/all/all/Valtioneuvoston%20yleisistunto',
    },
    se: {
      term: 'Statsrådets allmänna sammanträde',
      explanation:
        'I statsrådet allmänna sammanträde fattar regeringen beslut, bland annat om vilka regeringens förslag som ska lämnas till riksdagen.',
      source_text:
        'Termbank Valter: Statsrådets allmänna sammanträde',
      source_url:
        'https://valter.sanakirja.fi/all/all/valtioneuvoston%20yleisistunto',
    },
  },
  {
    fi: {
      term: 'Voimaantulo',
      explanation:
        'Ajankohta, jolloin säädös tulee voimaan ja sitovaksi. Ajankohta, jolloin säädöstä aletaan soveltaa. Määritellään yleensä säädöksessä taikka erillisellä voimaantulolailla.',
      source_text:
        'Tieteen termipankki: Säädöksen voimaantulo',
      source_url:
        'https://tieteentermipankki.fi/wiki/Oikeustiede:s%C3%A4%C3%A4d%C3%B6ksen_voimaantulo',
    },
    se: {
      term: 'Ikraftträdande',
      explanation:
        'Tidpunkten då en författning träder i kraft och blir bindande samt börjar tillämpas. Anges vanligtvis i själva författningen eller i en särskild lag om ikraftträdande.',
      source_text: 'Termbank Valter: Ikraftträdande',
      source_url:
        'https://valter.sanakirja.fi/all/all/voimaantulo',
    },
  },
  {
    fi: {
      term: 'Voimaantulosäännös',
      explanation:
        'Jokaisessa säädöksessä oleva säännös, joka määrittelee miten ja milloin kyseinen säädös tulee voimaan.',
      source_text: 'Finlex: Lainkirjoittajan opas',
      source_url:
        'http://lainkirjoittaja.finlex.fi/20-voimaantulo/20-2/',
    },
    se: {
      term: 'Ikraftträdandebestämmelse',
      explanation:
        'En bestämmelse i varje författning som anger hur och när författningen träder i kraft.',
      source_text:
        'Termbank Valter: Ikraftträdandebestämmelse',
      source_url:
        'https://valter.sanakirja.fi/all/all/voimaantulos%C3%A4%C3%A4nn%C3%B6s',
    },
  },
];

export const getAllTerms = (lang) => {
  const otherLang = lang === 'fi' ? 'se' : 'fi';

  // generate simpler objects for each term
  const termsForLanguage = legislativeTerms.map((term) => {
    const otherLangTerm = term[otherLang].term;
    // "(ruotsiksi xxx)" or "(på finska xxx)"
    const translationText = `(${translation('sanakirja_translation', lang)} "${otherLangTerm}")`;

    return {
      term: term[lang].term,
      translation: translationText,
      explanation: term[lang].explanation,
      source_text: term[lang].source_text,
      source_url: term[lang].source_url,
    };
  });

  // sort alphabetically
  return termsForLanguage.sort((a, b) => {
    return a.term.localeCompare(b.term, 'fi');
  });
};
